// extracted by mini-css-extract-plugin
export default {"link":"ZO-z","disabled":"_O-z"};